import React, { Component } from "react";
import PropTypes from "prop-types";
import { core } from "react-page-maker";

class Palette extends Component {
  /**
   * function to render the dragged element
   * @param props {Object} - An object which hold the info of dragged element/component
   * @returns JSX
   */

  _renderList = (props) => {
    const element = core
      .getRegisteredPaletteElements()
      .find((e) => e.type === props.type);
    return element ? <element.component {...props} /> : null;
  };

  render() {
    const { paletteElements, tabId } = this.props;

    return (
      <div className="palette">
        {paletteElements.map((item, index) => {
          const isPreview = item.options && item.options.showPreview;
          console.log(item)
          if (["checkout_steps"].includes(item.id)) {
            return <></>
          }
          return (
            <div
              key={index}
              className={`item ${isPreview ? "preview" : "not-preview"}`}
            >
              {this._renderList({
                ...item,
                key: item.id,
                showBasicContent: true,
                tabId,
              })}
            </div>
          );
        })}
      </div>
    );
  }
}

Palette.propTypes = {
  paletteElements: PropTypes.arrayOf((propValue) => {
    let isError = false;

    // all palette elements should have unique ID
    propValue.forEach((item) => {
      if (item && !item.id) {
        isError = "`id` is required in all palette element";
      }

      if (propValue.filter((i) => i.id === item.id).length > 1) {
        isError = "`id` of palette element should be unique";
      }
    });

    return isError ? new Error(isError) : true;
  }),
};

Palette.defaultProps = {
  paletteElements: [],
};

export default Palette;
